<template>
  <div class="contain">
    <!-- 검색 영역 -->
    <div class="search_form" ref="search_form">
      <el-form
        :inline="true"
        :model="searchForm"
        :label-position="`left`"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <el-row>
          <!-- 사용 가능 여부 -->
          <el-col :span="12">
            <el-form-item :label="$t('사용 가능 여부')">
              <combo
                :data="mainVue.code.useYn"
                :label="$t('전체')"
                :model="searchForm.useYn"
                @change="searchForm.useYn = $event"></combo>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 버튼 -->
    <div class="buttons" ref="buttons">
      <el-button v-if="checkAuthActionAccess('AiInfoSearch')" :size="size" @click="search" icon="el-icon-search">{{
        $t('검색')
      }}</el-button>
      <el-button
        v-if="checkAuthActionAccess('AiInfoAdd')"
        :size="size"
        @click="add"
        icon="el-icon-circle-plus-outline"
        :disabled="btn.addDisabled"
        >{{ $t('등록') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('AiInfoUp')"
        :size="size"
        @click="up"
        icon="el-icon-edit-outline"
        :disabled="btn.upDisabled"
        >{{ $t('수정') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('AiInfoDel')"
        :size="size"
        @click="del"
        icon="el-icon-remove-outline"
        :disabled="btn.delDisabled"
        >{{ $t('삭제') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('AiInfoAdd') || checkAuthActionAccess('AiInfoUp')"
        :size="size"
        @click="save"
        icon="el-icon-check"
        :disabled="btn.saveDisabled"
        style="float: right"
        class="hide-on-mobile"
        >{{ $t('저장') }}</el-button
      >
    </div>

    <!-- 리스트 -->
    <el-row :gutter="20">
      <el-col :md="10">
        <el-table
          :height="tableHeight"
          ref="table"
          border
          stripe
          highlight-current-row
          tooltip-effect="dark"
          :data="tableData"
          :size="size"
          :empty-text="$t('데이타 없음')"
          @row-click="handleRowClick"
          @select="handleRowChecked"
          @select-all="handleRowChecked">
          <!-- row 번호 -->
          <el-table-column
            :label="tableData.length.toString()"
            type="index"
            width="55"
            align="center"
            sortable
            :fixed="!$device.mobile"
            label-class-name="data_cnt"></el-table-column>
          <!-- 체크박스 -->
          <el-table-column type="selection" width="45" align="center" :fixed="!$device.mobile"></el-table-column>

          <!-- AI 종류 -->
          <el-table-column
            :label="$t('AI 종류')"
            prop="aiTp.nm"
            min-width="120"
            align="center"
            show-overflow-tooltip></el-table-column>
          <!-- 토큰 -->
          <el-table-column :label="$t('토큰')" prop="token" min-width="80" show-overflow-tooltip></el-table-column>
          <!-- 모델 -->
          <el-table-column :label="$t('모델')" prop="model" min-width="120" show-overflow-tooltip></el-table-column>
          <!-- 우선순위 -->
          <el-table-column :label="$t('우선순위')" prop="priority" width="80" align="center"></el-table-column>
          <!-- 사용 가능 여부 -->
          <el-table-column
            :label="$t('사용 가능')"
            prop="useYn"
            min-width="100"
            align="center"
            :formatter="mainVue.formatterCode"></el-table-column>
        </el-table>
      </el-col>

      <el-col :md="14">
        <el-card shadow="never" :style="{ height: inputHeight + 'px' }" class="input-menu">
          <div slot="header">
            <span>{{ $t('AI 정보') }}</span>
            <span v-if="'I' == inputForm.statu">{{ $t('추가') }}</span>
            <span v-if="'U' == inputForm.statu">{{ $t('수정') }}</span>
          </div>
          <div>
            <el-form
              :model="inputForm"
              :label-width="$device.mobile ? `` : `120px`"
              label-suffix=":"
              :size="size"
              :disabled="fromDisabled"
              @submit.native.prevent>
              <el-row :gutter="50">
                <!-- AI 종류 (코드) -->
                <el-col :md="12">
                  <el-form-item :label="$t('AI 종류')" :error="formError['aiTp.cd']" required>
                    <code-combo :data="aiTpList" :model="inputForm.aiTp" @change="inputForm.aiTp = $event"></code-combo>
                  </el-form-item>
                </el-col>

                <!-- 사용 가능 여부 -->
                <el-col :md="12">
                  <el-form-item :label="$t('사용 가능 여부')" required>
                    <combo
                      :data="mainVue.code.useYn"
                      :model="inputForm.useYn"
                      @change="inputForm.useYn = $event"></combo>
                  </el-form-item>
                </el-col>

                <!-- 우선순위 -->
                <el-col :md="12">
                  <el-form-item :label="$t('우선순위')" :error="formError.priority">
                    <el-input v-model="inputForm.priority" type="number"></el-input>
                  </el-form-item>
                </el-col>

                <!-- 토큰 -->
                <el-col :md="12">
                  <el-form-item :label="$t('토큰')" :error="formError.token">
                    <el-input v-model="inputForm.token" clearable show-word-limit></el-input>
                  </el-form-item>
                </el-col>

                <!-- 모델 -->
                <el-col :md="12">
                  <el-form-item :label="$t('모델')" :error="formError.model">
                    <el-input v-model="inputForm.model" clearable show-word-limit></el-input>
                  </el-form-item>
                </el-col>

                <!-- 보이스 -->
                <el-col :md="12">
                  <el-form-item :label="$t('보이스')" :error="formError.voice">
                    <el-input v-model="inputForm.voice" clearable show-word-limit></el-input>
                  </el-form-item>
                </el-col>

                <!-- 인스트럭션 -->
                <el-col :span="24">
                  <el-form-item :label="$t('AI 지시어')" :error="formError.instructions">
                    <el-input
                      type="textarea"
                      v-model="inputForm.instructions"
                      :autosize="{ minRows: 6, maxRows: 16 }"></el-input>
                  </el-form-item>
                </el-col>

                <!-- 수동 설정 -->
                <el-col :span="24">
                  <el-form-item :label="$t('추가 설정')" :error="formError.config">
                    <el-input
                      type="textarea"
                      v-model="inputForm.config"
                      :autosize="{ minRows: 6, maxRows: 16 }"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>

            <el-button
              v-if="checkAuthActionAccess('AiInfoAdd') || checkAuthActionAccess('AiInfoUp')"
              :size="size"
              @click="save"
              icon="el-icon-check"
              :disabled="btn.saveDisabled"
              style="float: right"
              class="hide-on-desktop"
              >{{ $t('저장') }}</el-button
            >
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { initData } from '@/utils/constants'
import mainVueMixin from '@/mixins/mainVueMixin'

export default {
  mixins: [mainVueMixin],

  data: function () {
    var data = initData()

    // 서버 Controller URL
    data.url = '/aiInfo'

    // AI 종류(코드) 목록
    data.aiTpList = []

    // 검색용 폼 (useYn만)
    data.searchForm = {
      useYn: 'Y',
    }

    // 입력(상세) 폼
    data.inputForm = {
      statu: 'I', // 'I': 등록, 'U': 수정
      aiInfoCd: null, // PK
      aiTp: { cd: '', nm: '' },
      token: '',
      model: '',
      voice: '',
      priority: null,
      instructions: '',
      config: '',
      useYn: 'Y',
    }

    // 폼 에러 객체
    data.formError = {
      'aiTp.cd': '',
      token: '',
      model: '',
      voice: '',
      priority: '',
      instructions: '',
      config: '',
    }

    return data
  },
  created: function () {
    this.initAiTpList() // AI 종류 코드 조회
    this.search()
  },
  mounted: function () {
    setTimeout(
      function () {
        this.$nextTick(
          function () {
            this.mainVue.currVue = this
          }.bind(this)
        )
      }.bind(this),
      500
    )
  },
  methods: {
    // AI 종류(코드) 목록 조회
    initAiTpList: function () {
      this.mainVue.$axios.search(
        '/code/getCode/AI_TP',
        null,
        function (result) {
          this.aiTpList = result
        }.bind(this),
        false
      )
    },

    // 테이블 행 클릭
    handleRowClick: function (row) {
      if (row) {
        this.btn.upDisabled = false
      }
      this.selectData = row
    },

    // 체크박스 선택
    handleRowChecked: function (selection, row) {
      this.btn.delDisabled = selection.length === 0
      this.checkedData = selection.map((item) => item.aiInfoCd)
    },

    // 검색
    search: function () {
      // GET /aiInfo?useYn=...
      let param = '?useYn=' + (this.searchForm.useYn || '')
      this.mainVue.$axios.search(
        this.url + param,
        null,
        function (result) {
          this.tableData = result
          // 버튼 상태 초기화
          this.btn.addDisabled = false
          this.btn.upDisabled = true
          this.btn.delDisabled = true
          this.btn.saveDisabled = true
          this.fromDisabled = true

          // 입력 폼 초기화
          this.initInputForm()
        }.bind(this),
        false
      )
    },

    // 입력폼 초기화
    initInputForm: function () {
      this.inputForm = {
        statu: 'I',
        aiInfoCd: null,
        aiTp: { cd: '', nm: '' },
        token: '',
        model: '',
        voice: '',
        priority: null,
        instructions: '',
        config: '',
        useYn: 'Y',
      }
      this.formError = {
        'aiTp.cd': '',
        token: '',
        model: '',
        voice: '',
        priority: '',
        instructions: '',
        config: '',
      }
    },

    // 등록
    add: function () {
      this.initInputForm()
      this.btn.saveDisabled = false
      this.fromDisabled = false
    },

    // 수정
    up: function () {
      if (!this.selectData) return
      // GET /aiInfo/{aiInfoCd}
      this.mainVue.$axios.get(
        this.url + '/' + this.selectData.aiInfoCd,
        function (result) {
          result.statu = 'U'
          this.inputForm = result

          this.formError = {
            'aiTp.cd': '',
            token: '',
            model: '',
            voice: '',
            priority: '',
            instructions: '',
            config: '',
          }

          this.btn.saveDisabled = false
          this.fromDisabled = false
        }.bind(this),
        true
      )
    },

    // 삭제
    del: function () {
      if (!this.checkedData || this.checkedData.length === 0) return
      this.mainVue
        .$confirm(this.$t('AI 정보를 삭제 하시겠습니까?'), this.mainVue.appMsg.systemAlterTitle, {
          confirmButtonText: this.$t('삭제'),
          cancelButtonText: this.$t('취소'),
          type: 'info',
        })
        .then(
          function () {
            let ids = this.checkedData.join(',')
            // DELETE /aiInfo/{aiInfoCds}
            this.mainVue.$axios.del(
              this.url + '/' + ids,
              function (result) {
                this.mainVue.$message({ type: 'success', message: this.$t('삭제 성공') })
                this.search()
              }.bind(this),
              true
            )
          }.bind(this)
        )
        .catch(
          function () {
            this.mainVue.$message({ type: 'info', message: this.$t('삭제 취소') })
          }.bind(this)
        )
    },

    // 저장 (등록/수정 구분)
    save: function () {
      this.formError = {
        'aiTp.cd': '',
        token: '',
        model: '',
        voice: '',
        priority: '',
        instructions: '',
        config: '',
      }

      // I: 등록
      if ('I' === this.inputForm.statu) {
        this.mainVue.$axios.add(
          this.url,
          this.inputForm,
          this.formError,
          function (result) {
            this.mainVue.$message({ type: 'success', message: this.$t('등록 성공') })
            this.search()
          }.bind(this),
          true
        )
      }
      // U: 수정
      else {
        let aiInfoCd = this.inputForm.aiInfoCd
        this.mainVue.$axios.up(
          this.url + '/' + aiInfoCd,
          this.inputForm,
          this.formError,
          function (result) {
            this.mainVue.$message({ type: 'success', message: this.$t('수정 성공') })
            this.search()
          }.bind(this),
          true
        )
      }
    },
  },
}
</script>
